module.exports = __webpack_public_path__ + "img/CPS200.35df3e0e.png";